import React, { useEffect, useRef, useState } from 'react';
import '../styles/Academics.css';

const AcademicSection = () => {
  const [isVisible, setIsVisible] = useState({});
  const sectionRefs = useRef({});

  useEffect(() => {
    const observers = {};
    
    Object.keys(sectionRefs.current).forEach(key => {
      if (sectionRefs.current[key]) {
        observers[key] = new IntersectionObserver(
          (entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                setIsVisible(prev => ({ ...prev, [key]: true }));
              }
            });
          },
          { threshold: 0.1 }
        );
        
        observers[key].observe(sectionRefs.current[key]);
      }
    });

    return () => {
      Object.values(observers).forEach(observer => observer.disconnect());
    };
  }, []);

  return (
    <div className="academic-wrapper">
       {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Academics</h1>
          </div>
        </div>
      </section>

      {/* Curriculum Section */}
      <section className="content-section">
        <div className="container">
          
          <div
            ref={el => sectionRefs.current['curriculum'] = el}
            className={`fade-in-section ${isVisible['curriculum'] ? 'visible' : ''}`}
          >
            <h2 className="section-title">Curriculum</h2>
            <p className="section-text">
              The School provides education from nursery to senior secondary classes. Besides scholastic area co-scholastic area is also given equal emphasis provide a congenial atmosphere for learning. The number of students per section is enhanced optimum so that teachers can give their personal attention to every student.
            </p>
          </div>

          <div
            ref={el => sectionRefs.current['improve'] = el}
            className={`fade-in-section ${isVisible['improve'] ? 'visible' : ''}`}
          >
            <h2 className="section-title">Improve the future of your child with The School</h2>
            <p className="section-text">
              IDEAL EDUCATION POINT SETH.G.L BIHANI S.D SENIOR SECONDARY SCHOOL is a co-educational Senior Secondary School, incorporating the very best of educational methods, inspired and guided by an innovative and genuinely modern educational philosophy. In SriGanganagar, this is the Best RBSE School for commerce, Maths, Science, Agriculture built on a vast campus, provides a pollution-free atmosphere far from the city life's maddening crowd. IDEAL EDUCATION POINT SETH G.L BIHANI S.D SENIOR SECONDARY SCHOOL is the Best RBSE School for commerce, Maths, Science, Agriculture has introduced computer-aided learning in all aspects of education and learning in order to keep pace with technological advances and lead to the 21st century, to maximize the efficiency of the process. Education should spark young minds into exploring the vast horizon of knowledge, seeking answers to their questions, building dreams and pursuing goals that seek happiness for all.
            </p>
          </div>

          <div
            ref={el => sectionRefs.current['evaluation'] = el}
            className={`fade-in-section ${isVisible['evaluation'] ? 'visible' : ''}`}
          >
            <h2 className="section-title">Evaluation</h2>
            <p className="section-text">
              Various Examinations are organized to assess the academic performance of students whose dates are announced by the education department and the board of secondary education. on the basis of previous experience these examinations as Follows:
            </p>
            <ul className="exam-list">
              <li>First Test - August</li>
              <li>Second Test - October</li>
              <li>Half Yearly Exam - December</li>
              <li>Third Test - February</li>
            </ul>
            <p className="section-text">
              Examination conducted by the board - Class 5,8 [As per the time announced by the education Department] and for students of class 10th and 12th in the month of March.
            </p>
            <p className="section-text">
              Annual Examination at school level it will be held in the month of April for all the classes except board Classes.
            </p>
            <p className="note-text">
              Note - Only the date of examination declared by the education department and the board of secondary education will be valid
            </p>
          </div>

          <div
            ref={el => sectionRefs.current['discipline'] = el}
            className={`fade-in-section ${isVisible['discipline'] ? 'visible' : ''}`}
          >
            <h2 className="section-title">ACADEMIC DISCIPLINE</h2>
            <p className="section-text">
              The Academy aims at a high standard of ethics and discipline. The Academy's code of conduct is included in its rules. The Academy does not believe in corporal punishment to maintain discipline.
            </p>
            <p className="section-text">
              If a child errs, she/he will be courteously informed of the infringement. In case a student becomes disruptive, or violent the academy will take recourse to time-out and any other measures that it may be fine etc. necessary for the purpose. Parents may be called to take the students away. The student can return only when she/he is willing to follow the discipline of the Academy. The Academy reserves the right to expel a student in case of a very serious breach of discipline.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AcademicSection;